import { useState } from 'react';
import { TrendingUp } from 'lucide-react';

interface StockLogoProps {
  symbol: string;
  size?: number;
  className?: string;
}

const LOGO_PROVIDERS = [
  // Primary: Financial Modeling Prep
  (symbol: string) => `https://financialmodelingprep.com/image-stock/${symbol.toUpperCase()}.png`,
  // Fallback 1: Clearbit (works for many stocks)
  (symbol: string) => `https://logo.clearbit.com/${symbol.toLowerCase()}.com`,
  // Fallback 2: Logo.dev
  (symbol: string) => `https://img.logo.dev/ticker/${symbol.toUpperCase()}?token=pk_demo`,
  // Fallback 3: Elbstream
  (symbol: string) => `https://assets.elbstream.com/logos/${symbol.toUpperCase()}.png`,
  // Fallback 4: Yahoo Finance
  (symbol: string) => `https://logo.yahoo.com/finance/${symbol.toLowerCase()}`,
];

export function StockLogo({ symbol, size = 40, className = '' }: StockLogoProps) {
  const [currentProviderIndex, setCurrentProviderIndex] = useState(0);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    // Try next provider
    if (currentProviderIndex < LOGO_PROVIDERS.length - 1) {
      setCurrentProviderIndex(currentProviderIndex + 1);
    } else {
      // All providers failed, show fallback icon
      setHasError(true);
    }
  };

  if (hasError) {
    // Fallback icon when all providers fail
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg ${className}`}
        style={{ width: size, height: size }}
      >
        <TrendingUp className="text-white" style={{ width: size * 0.6, height: size * 0.6 }} />
      </div>
    );
  }

  const logoUrl = LOGO_PROVIDERS[currentProviderIndex](symbol);

  return (
    <img
      src={logoUrl}
      alt={`${symbol} logo`}
      onError={handleError}
      className={`rounded-lg object-contain bg-white/5 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

